(() => {
  window.swinger.observer.initialize('.swinger-tabs__tablist', (elem) => {
    elem.setAttribute('role', 'tablist');
    elem.setAttribute('aria-orientation', 'horizontal');
  }, false);

  window.swinger.observer.initialize('.swinger-tabs__tablist-item', (elem) => {
    elem.setAttribute('role', 'presentation');
  }, false);

  window.swinger.observer.initialize('.swinger-tabs__tablist-item:first-child .swinger-tabs__tablist-link', (elem) => {
    elem.setAttribute('aria-selected', 'true');
  }, false);

  window.swinger.observer.initialize('.swinger-tabs__tablist-link', (elem) => {
    elem.setAttribute('role', 'tab');
  }, false);

  window.swinger.observer.initialize('.swinger-tabs__tabpanel', (elem) => {
    elem.setAttribute('role', 'tabpanel');
    elem.setAttribute('aria-labelledby', elem.getAttribute('data-aria-labelledby'));
  }, false);

  window.swinger.observer.initialize('.swinger-tabs__tabpanel ~ .swinger-tabs__tabpanel', (elem) => {
    window.swinger.visibility.hide(elem);
  }, false);
})();
